import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform,IonInfiniteScroll,IonSlides } from '@ionic/angular';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { BaseModal } from '../../../../model/base';
import { WebParameterContext } from '../../../../model/common';
import { BaseCase } from '../../../basecase';
import { CommonService } from '../../../../service/common.service';
declare var app;

@Component({
  selector: 'app-sfa-collection-result',
  templateUrl: './sfa-collection-result.component.html',
  styleUrls: ['./sfa-collection-result.component.scss']
})
export class SfaCollectionResultComponent extends GridBaseCase {
  searchType: number = 0;//搜索类型(门店，分类，地图)
  searchTypeNum: number = 0;//分类筛选（分类筛选中按门店、按人员、按渠道）
  searchTypemendian: number = 0;//门店/经销商
  qudaoNumber: number = null;//渠道
  personNumber: number = null;//人员
  searchVal: string = '';//输入搜索值
  chage: any;
  dataChannelArrayList = [];//获取渠道结果值
  dataPersonArrayList = [];//获取人员结果值
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonSlides) ionSlides: IonSlides;
  RecordCount: Number = 0;//列表总数量
  photoIndex = 1;
  photoList: Array<any> = [];
  constructor(
    private platform: Platform,
    private activaRouter: ActivatedRoute,
    private router:Router,
    private msg: MessageclientService,
    private http: HttpCustomerService,
    public base: BaseModal,
    public baseService: BaseCase,
    public com: CommonService
  ) { super(); }


  EventSlideChange($event) {
    console.log($event);
    let that = this;
    this.ionSlides.getActiveIndex().then(data=>{
      that.photoIndex = data + 1;
    })
  }

  ImgPreview(index){
    let that = this;
    const url = [];
    that.photoList.forEach(item=>{
      url.push(item);
    });
    let ImgPreview = {
      imgUrl:url,
      index:index
    }
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    that.com.Go("/tabs/contact/ImgPreview",{
      ImgPreview:JSON.stringify(ImgPreview)
    });
  }

  slideOpts = {

    // "autoplay":item.content.autoplay,
    "spaceBetween": 10,//间隔
    "slidesPerView": this.photoList.length > 1?3:1,//每个视图几个item
    "slidesPerGroup": this.photoList.length > 1?3:1,
    "loop": false,
    // "initialSlide": 0,//第一个索引
    "centeredSlides": false,//当前项居中
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }

  LoadData(PageNumber) {
    let that = this;
    this.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    console.log(PageNumber,"PageNumber");
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const mId = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    // if (!that.com.GetAccount.IsAdmin) {
    //   let startDate = that.com.getNow + " 00:00:00";
    //   let endDate = that.com.getNow + " 23:59:59";
    //   let date = that.com.BetweenDate(startDate, endDate);
    //   body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID": that.com.GetAccount.Id, "a_Code": 'S002', "a_VisitDate": date });
    //   // body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_Code":'S002'});
    // }

    //
    // if(mId){
      body.RequestBody = JSON.stringify({ "a_TaskID": mId});
    // }else{
    //   body.RequestBody = JSON.stringify({ "m_FK_SystemUser_ID": that.com.GetAccount.Id, "m_FK_TBStore_ID": that.com.GetStorageKey("tbstore")["ID"], "m_TaskDate": that.com.getNow});
    // }
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      console.log("111");
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } 
      else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        if(data.Status.Datas.length<=0){
          document.getElementsByName("appeal")[0].style.display="none";
        }
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          // console.log(that.dataArrayList);

        });
        if(that.dataArrayList[0]){
          that.photoList = that.dataArrayList[0]['photo']['value'].split(",");
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          that.infiniteScroll.disabled = true;
        } else {
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }


  searchChange($event, type) {
    // console.log(this.baseService.storeSearch,$event);
    if ($event.keyCode == 13 || type == 'search') {
      // this.myChild.LoadData();
    }
  }
  cancalEvent() {
    this.searchType = 0;
    // this.baseService.storeSearch.searchType = 0;
    // this.baseService.storeSearch = {};
    // this.myChild.LoadData();
  }

  comfireEvent() {
    this.searchType = 0;

  }
  /**
   * 
   * @param n 搜索类型类型
   */
  search(n: number): void {
    // this.searchType == n ? this.searchType = 0 : this.searchType = n;
    if (this.searchType == n) {
      this.searchType = 0;
      this.baseService.storeSearch.searchType = 0;
    } else {
      this.searchType = n;
      this.baseService.storeSearch.searchType = n;
    }
  }
  //类型
  searchEvent(n: number): void {
    // if(this.searchTypeNum == n){
    //   this.searchTypeNum = 0;
    // }else{
    //   this.searchTypeNum = n;
    // }
    this.searchTypeNum = n;
    if (this.searchTypeNum == 1 && this.dataPersonArrayList.length == 0) {//表示人员
      this.bindLoadPersonData();
    }
    if (this.searchTypeNum == 2 && this.dataChannelArrayList.length == 0) {//表示渠道
      this.bindLoadChannelData();
    }
  }
  //门店经销商
  Eventserch(n: number): void {
    if (this.searchTypemendian == n) {
      this.searchTypemendian = 0;
    } else {
      this.searchTypemendian = n;
    }
    this.baseService.storeSearch.ObjectType = n + 1;//门店、经销商
  }

  //人员
  EventserchPerson(n: number): void {
    if (this.personNumber == n) {
      this.personNumber = null;
    } else {
      this.personNumber = n;
    }
    if (this.personNumber == null) {
      this.baseService.storeSearch.userId = null;//人员
    } else {
      let a_ID = this.dataPersonArrayList[n]["ID"];
      this.baseService.storeSearch.userId = a_ID;//人员
    }
  }

  //渠道
  Eventserchqudao(n: number): void {
    if (this.qudaoNumber == n) {
      this.qudaoNumber = null;
    } else {
      this.qudaoNumber = n;
    }

    if (this.qudaoNumber == null) {
      this.baseService.storeSearch.FK_TBStoreChannel_ID = null;//渠道
    } else {
      let a_ID = this.dataChannelArrayList[n]["a_ID"];
      this.baseService.storeSearch.FK_TBStoreChannel_ID = a_ID;//渠道
    }
  }






  /**
   * 渠道数据
   */
  bindLoadChannelData() {
    let that = this;
    // that.loading = false;
    // that.apiObj['status'] = false;
    // that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    // if (that.element.selectItemList.gridViewConfigName) {
    //   body.ConfigName = that.element.selectItemList.gridViewConfigName;
    // } 
    body.ConfigName = "TBStoreChannelXML";//获取对应的渠道数据
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // if(!that.com.GetAccount.IsAdmin){
    //   console.log(that.baseService.storeSearch.name);
    //   if(that.baseService.storeSearch.name){
    //     body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ObjectName":that.baseService.storeSearch.name});
    //   }else{
    //     body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id});
    //   }
    // }
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.dataChannelArrayList = [];
      // setTimeout(function () {
      //   that.apiObj['status'] = data.ResponseMessage.Success;
      //   that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      //   that.loading = true;
      // });
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          //  console.log(item);
          that.dataChannelArrayList.push(item);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
      }

    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      // that.loading = true;
      console.log(error);
    })

  }

  /**
   * 人员数据
   */
  bindLoadPersonData() {
    let that = this;
    // that.loading = false;
    // that.apiObj['status'] = false;
    // that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    // if (that.element.selectItemList.gridViewConfigName) {
    //   body.ConfigName = that.element.selectItemList.gridViewConfigName;
    // } 
    body.ConfigName = "UserApproverInfo";//获取对应的经销商,门店数据
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = JSON.stringify({ "userId": that.com.GetAccount.Id });
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.dataPersonArrayList = [{ 'userId': that.com.GetAccount.Id, 'ChineseName': that.com.GetAccount.DisplayName }];
      // setTimeout(function () {
      //   that.apiObj['status'] = data.ResponseMessage.Success;
      //   that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      //   that.loading = true;
      // });
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          //  console.log(item);
          that.dataPersonArrayList.push(item);
        });
      }

    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      // that.loading = true;
      console.log(error);
    })

  }

}
